import React from 'react';

import OrderReview from 'components/OrderReview';
import OrderCrossSells from 'components/OrderReview/OrderCrossSells';

import { OrderContainer } from './styles';

const Order = () => (
  <>
    <OrderCrossSells />
    <OrderContainer>
      <OrderReview />
    </OrderContainer>
  </>
);

export default Order;
